import { createSlice } from '@reduxjs/toolkit';

const designationSlice = createSlice({
    name: 'designation',
    initialState: {
        loading: false,
        designations: [],
        error: null,
        isCreated: false,
        isUpdated: false,
        isDeleted: false,
    },
    reducers: {
        designationRequest(state) {
            state.loading = true;
            state.error = null;
        },
        designationsSuccess(state, action) {
            state.loading = false;
            state.designations = action.payload;
        },
        designationCreateSuccess(state, action) {
            state.loading = false;
            state.designations = [...state.designations, action.payload];
            state.isCreated = true;
        },
        designationUpdateSuccess(state, action) {
            state.loading = false;
            state.designations = state.designations.map(t =>
                t._id === action.payload._id ? action.payload : t
            );
            state.isUpdated = true;
        },
        designationDeleteSuccess(state, action) {
            state.loading = false;
            state.designations = state.designations.filter(t => t._id !== action.payload);
            state.isDeleted = true;
        },
        designationFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        clearDesignationError(state) { state.error = null; },
        clearDesignationCreated(state) { state.isCreated = false; },
        clearDesignationUpdated(state) { state.isUpdated = false; },
        clearDesignationDeleted(state) { state.isDeleted = false; },
    },
});

export const {
    designationRequest,
    designationsSuccess,
    designationCreateSuccess,
    designationUpdateSuccess,
    designationDeleteSuccess,
    designationFail,
    clearDesignationError,
    clearDesignationCreated,
    clearDesignationUpdated,
    clearDesignationDeleted,
} = designationSlice.actions;

export default designationSlice.reducer;

